export function isAsyncFunction<Args extends any[], Result>(
  fn: (...args: Args) => MaybePromise<Result>
): fn is (...args: Args) => Promise<Result> | PromiseLike<Result> {
  return fn.constructor.name === 'AsyncFunction';
}

export function isSyncFunction<Args extends any[], Result>(
  fn: (...args: Args) => MaybePromise<Result>
): fn is (...args: Args) => Result {
  return fn.constructor.name !== 'AsyncFunction';
}
